import styled from 'styled-components';

const TextHoverAnimationsStyle = styled.div`
	&.textHoverAnimations {
		--textAnimVertPadding: var(--sp10x);

		position: relative;
		display: flex;
		align-items: center;
		padding-top: var(--sectionToSection);
		padding-bottom: var(--sectionToSection);
		margin-bottom: var(--sectionToSection);
		background-color: var(--color2);

		.txtCr {
			position: fixed;
			width: 7.27vw;
			top: 10%;
			left: 10%;
			transform: translate(-50%, -50%);
			pointer-events: none;

			.crImage {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				padding-top: 100%;
				opacity: 0;
			}
		}

		.another-svg {
			--maxWidth: 100%;

			max-width: var(--maxWidth);
			margin: 0 auto;
			width: 100%;
			padding-left: var(--containerPaddingLR);
			padding-right: var(--containerPaddingLR);
			overflow: visible;

			.lineMove {
				stroke-dashoffset: 3500;
				stroke-dasharray: 5000;
			}

			.transform-anim {
				transform-style: preserve-3d;
				transform-origin: 965px 290px;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.another-svg {
				--maxWidth: 100%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			.another-svg {
				--maxWidth: 90%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			.another-svg {
				--maxWidth: 90%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			.another-svg {
				--maxWidth: 86.3%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			.another-svg {
				--maxWidth: 86.3%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			.another-svg {
				--maxWidth: 86.3%;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			.another-svg {
				--maxWidth: 86.3%;
			}
		}

		tspan,
		text,
		polygon,
		path {
			fill: var(--color1);
			stroke: var(--color1);
		}
	}
`;

export default TextHoverAnimationsStyle;
